// import './App.css';
// import Login from './Login/Login';
// import MainPage from './component/MainPage/MainPage';
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
// import {createBrowserRouter,RouterProvider} from 'react-router-dom'

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Login />,
//   },
//   {
//     path: "/dashboard",
//     element: <MainPage />,
//   },
//   {
//     path:"/home"
//   }
// ])
// function App() {
//   return (
//     <div className="App">
//      <RouterProvider router={router}/>
//     </div>
//   );
// }

// export default App;

import "./App.css";
import Login from "./Login/Login";
import MainPage from "./component/MainPage/MainPage";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  useNavigate,
  createBrowserRouter,
  Outlet,
  RouterProvider
} from "react-router-dom";

import UsersPage from "./component/Users/Users";
import DeviceSchedulePage from "./component/DeviceSchedule";
import ReportsPage from "./component/Reports";
import StoreRegionsPage from "./component/StoreRegions";
import StoreAnalyticsPage from "./component/StoreAnalytics";
import DeviceMasterPage from "./component/DeviceMaster";
import SideNav from "./component/Navigation/SideNav";
import AdminOnly from "./component/common/AdminOnly";

function AuthHandler() {
  const login = useSelector((state) => state.login);
  const navigate = useNavigate();

  useEffect(() => {
    if (Object.keys(login).length === 0) {
      navigate("/");
    } else {
      navigate("/home");
    }
  }, [login, navigate]);

  return null;
}
// Every signed-in page: the navigation sidebar on the left, the page beside it.
function AppLayout() {
  return (
    <div style={{ display: "flex", height: "100vh", width: "100vw", overflow: "hidden" }}>
      <SideNav />
      <div style={{ flex: 1, minWidth: 0, height: "100vh" }}>
        <Outlet />
      </div>
    </div>
  );
}

// Users, Store Master and Device Master are admin only (AdminOnly), and the
// sidebar hides them from other roles (adminOnly in Navigation/pages.js).
const appRoutes = [
  {
    path: "dashboard",
    element: <MainPage />,
  },
  {
    path: "dashboard/:type/:houseId/:roomId/:deviceId",
    element: <MainPage />,
  },
  {
    path: "users",
    element: (
      <AdminOnly>
        <UsersPage />
      </AdminOnly>
    ),
  },
  {
    path: "device-schedule",
    element: <DeviceSchedulePage />,
  },
  {
    path: "reports",
    element: <ReportsPage />,
  },
  {
    path: "store-master",
    element: (
      <AdminOnly>
        <StoreRegionsPage />
      </AdminOnly>
    ),
  },
  {
    // The page's old address, kept so bookmarks still work.
    path: "store-regions",
    element: (
      <AdminOnly>
        <StoreRegionsPage />
      </AdminOnly>
    ),
  },
  {
    path: "store-analytics",
    element: <StoreAnalyticsPage />,
  },
  {
    path: "device-master",
    element: (
      <AdminOnly>
        <DeviceMasterPage />
      </AdminOnly>
    ),
  },
  {
    // Alias: the sidebar links to /device-schedule, this is the spelling the
    // page was specified under. Same component either way.
    path: "deviceschedule",
    element: <DeviceSchedulePage />,
  },
];

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    element: <AppLayout />,
    children: appRoutes,
  },
  /*
  {
    path: "home",
    element: <DashBoard />,
  },
  {
    path: "",
    element: <SettingsPage />,
    children: [
      { path: "schedules", element: <ScheduleOperation /> },
      { path: "reports", element: <Report/> },
      { path: "megacontrollers", element: <MegaController/> },
      { path: "vrvcontrollers", element: <VRVController/> },
      // {path:'deviceStaus', element:<DeviceStatus/>},
          // { path: "schedules", element: <Navigate to="schedule-operation" replace /> },
          { path: "update-wifi", element: <UpdateWifi /> },
          { path: "edit-names", element: <EditName /> },
          // { path: "schedule-operation", element: <div>Schedule Operation</div> },
          // { path: "schedule-operation", element: <ScheduleOperation /> },
          { path: "temperature-trigger", element: <div>Temperature Trigger</div> },
          // { path: "auto-on-off", element: <div>Auto ON/OFF</div> },
          { path: "auto-on-off", element: <div><AutoOnOff /></div> },
          // { path: "control-mechanism", element: <div>Control Mechanism</div> },
          { path: "control-mechanism", element: <ControlMechanism /> },
          { path: "share-access", element: <div>Share Access</div> },
          { path: "predictive-maintenance", element: <div>Predictive Maintenance</div> },
          { path: "alerts-notifications", element: <div>Alerts and Notifications</div> },
          { path: "savings-goal", element: <div>Enter Savings Goal</div> }
        ]
     
  },
  */
  /*
  {
    path: "summary",
    element: <SummaryPage />,
  },
  */
  // {
  //   path: "/home",
  //   element: <div>Home</div>
  // }
]);
function App() {
  return (
    <div className="App">
      <>
        <RouterProvider router={router}>
          <AuthHandler />
        </RouterProvider>
      </>
    </div>
  );
}

export default App;
